module.exports = __webpack_public_path__ + "img/vu.f25d8a36.svg";